import { toast } from "react-toastify"
import { ApiConfiguration } from "../../../services/http/api-configuration"
import ApiService from "../../../services/http/api-service"

export const registerUser = async (payload) => {
    try {
        const res = await ApiService.post(ApiConfiguration.register, payload)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}

export const verifyOtp = async (payload) => {
    try {
        const res = await ApiService.post(ApiConfiguration.verifyOtp, payload)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}

export const loginUser = async (payload) => {
    try {
        const res = await ApiService.post(ApiConfiguration.login, payload)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}

export const sendOtp = async (payload) => {
    try {
        const res = await ApiService.post(ApiConfiguration.sendOtp, payload)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}


export const changePassword = async (payload) => {
    try {
        const res = await ApiService.post(ApiConfiguration.forgotPassword, payload)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}


export const getMembersipList = async () => {
    try {
        const res = await ApiService.get(ApiConfiguration.membershipList)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}

export const purchaseMembership = async (payload) => {
    try {
        const res = await ApiService.post(ApiConfiguration.purchaseMembership, payload)
        return res.data
    } catch (err) {
        toast.error(err.response.data.message)
        throw new Error(err)
    }
}
